import { gsap } from '../animations';

/**
 * Block "Marquee": le righe della mega-headline traslano in direzioni opposte
 * mentre la sezione attraversa il viewport (scroll-scrubbed, counter-marquee).
 */
export function initMarquee() {
	// Con reduced-motion lasciamo le righe ferme (la spaziatura le tiene leggibili).
	if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
		return;
	}

	document.querySelectorAll( '[data-tm-marquee]' ).forEach( ( section ) => {
		const rows = section.querySelectorAll( '[data-marquee-row]' );
		const travel = 25; // ampiezza dello slittamento in % della larghezza riga.

		rows.forEach( ( row ) => {
			const dir = 'left' === row.dataset.direction ? -1 : 1;

			gsap.fromTo(
				row,
				{ xPercent: -travel * dir },
				{
					xPercent: travel * dir,
					ease: 'none',
					scrollTrigger: {
						trigger: section,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
						// will-change solo mentre la sezione è nel viewport: niente layer GPU a riposo.
						onToggle: ( self ) => {
							row.style.willChange = self.isActive ? 'transform' : 'auto';
						},
					},
				}
			);
		} );
	} );
}
